const IMAGE_CONTENT_TYPES = {
  WITHOUT: "without",
  RIGHT: "right",
  LEFT: "left",
  BOTTOM: "bottom",
}

export default IMAGE_CONTENT_TYPES
